import ChangePhoneNumberScreen from 'features/myVaro/screens/PersonalDetails/ChangePhoneNumber/ChangePhoneNumberScreen';
import React from 'react';

export default function ChangePassword() {
  return <ChangePhoneNumberScreen />;
}
